module.exports = __webpack_public_path__ + "media/v2/components/HowToPlay/img/2_step-e888a8869db146056a9b60fe97a18f03.png";